<template>
  <section :class="$style.component">
    <button :class="$style.close" @click="closeSlider" />
    <div :class="$style.content">
      <div :class="$style.slider">
        <transition name="t-slide">
          <image-slide :image="currentItem" :key="currentSlide" />
        </transition>
      </div>
    </div>
    <div :class="$style.nav">
      <button :class="classes.prev" @click="prev" />
      <button :class="classes.next" @click="next" />
    </div>
  </section>
</template>

<script>
import ImageSlide from '@/components/image-slide.vue'
import EventBus from '@/event-bus.js'

export default {
  components: {
    ImageSlide
  },
  props: {
    media: {
      type: Array,
      required: true
    },
    slide: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      currentSlide: this.slide,
      slideCount: this.media.length,
      onEnteredSlide: true
    }
  },
  computed: {
    classes() {
      return {
        prev: [this.$style.prev, this.showNav ? this.$style['is-visible'] : ''],
        next: [this.$style.next, this.showNav ? this.$style['is-visible'] : '']
      }
    },
    firstSlide() {
      return this.currentSlide === 0
    },
    lastSlide() {
      return this.currentSlide === this.slideCount - 1
    },
    showNav() {
      return this.onEnteredSlide
    },
    currentItem() {
      return this.media[this.currentSlide]
    }
  },
  methods: {
    prev() {
      if (this.firstSlide) {
        this.currentSlide = this.slideCount - 1
        return
      } else {
        this.currentSlide--
      }
      this.onEnteredSlide = false
    },
    next() {
      this.currentSlide = (this.currentSlide + 1) % this.slideCount
      this.onEnteredSlide = false
    },
    closeSlider() {
      EventBus.$emit('close-slider')
    }
  }
}
</script>

<style lang="scss" scoped>
.t-slide-enter-active,
.t-slide-leave-active {
  transition: opacity var(--xlong) ease;
}

.t-slide-enter,
.t-slide-leave-to {
  opacity: 0;
}
</style>

<style lang="scss" module>
.component {
  position: relative;
  height: 100%;
  padding-top: calc(var(--gutter) * 5);
  background-color: var(--white);

  @media (min-aspect-ratio: 3/2) {
    padding-top: 0;
    padding-right: 20vw;
  }
}

.close {
  position: absolute;
  z-index: 2;
  top: var(--gutter);
  left: var(--gutter);

  &:after {
    @extend %ff-symbols;
    @extend %fs-title;
    content: '\e000';
  }
}

.content {
  height: 100%;
}

.prev,
.next {
  @extend %tap-highlight-reset;
  @extend %cursor-pointer;
  display: block;
  position: fixed;
  z-index: 1;
  top: 0;
  width: 50%;
  height: 100%;
  padding: var(--gutter);
  outline: 0;

  &:after {
    @extend %ff-symbols;
    @extend %fs-title;
    content: '\e001';
    display: inline-block;
    opacity: 0;
    transition: opacity var(--short) ease;
  }

  @media (min-aspect-ratio: 3/2) {
    &.is-visible:after {
      opacity: 1;
    }
  }
}

.prev {
  left: 0;
  text-align: left;

  &:after {
    transform: scaleX(-1);
  }
}

.next {
  right: 0;
  text-align: right;
}

.slider {
  position: relative;
  height: 100%;
}
</style>
